import type { VoidFunctionComponent } from 'react';

import Toggle from '../../generic/Toggle';

import styles from './RegulatoryComplianceToggle.module.less';

type Props = {
  isChecked: boolean;
  onChange: (isChecked: boolean) => void;
};

const TOGGLE_ID = 'ntiaFdaFieldsToggle';

/**
 * Toggle that checks every field the NTIA/FDA SBOM requirements call for.
 */
export const RegulatoryComplianceToggle: VoidFunctionComponent<Props> = ({ isChecked, onChange }) => (
  <div className={styles.regulatoryComplianceToggle}>
    <div className={styles.toggle}>
      <Toggle id={TOGGLE_ID} checked={isChecked} onChange={onChange} />
      <label className={styles.label} htmlFor={TOGGLE_ID}>Check all NTIA/FDA fields</label>
    </div>
    <div className={styles.description}>
      You can require adherence to regulatory specifications. Currently the FDA follows the NTIA requirements.
    </div>
  </div>
);
